export default __webpack_public_path__ + "static/media/PF.d4469ace.jfif";